module.exports = "/assets/data/60f6b0c073ebe42a6a6572dc9cd585c3-EX6.data.json";